import moment from 'moment';
import { createSlice } from '@reduxjs/toolkit';
import errorHandle from './errorHandle';
import { enqueueSnackbar } from './notifierSlice';
import RecurringMessageService from '../services/RecurringMessageService';
import {
  RecurringMessageFrequencyType,
  RecurringMessageStatus,
  SnackBarType,
  LoginResultAwardMethod,
} from '../app/types';
import i18n from '../app/i18n';
import {
  validateText,
  validateMax,
  validateRecurringMessageContents,
} from '../app/utils';

export const recurringMessageSlice = createSlice({
  name: 'recurringMessage',
  initialState: {
    data: {
      name: `定期通知訊息 ${moment().format('YYYY-MM-DD')}`,
      keyword: '',
      award: {
        enabled: false,
        method: LoginResultAwardMethod.COUPON,
        value: '',
      },
      contents: {
        elements: [
          {
            title: '',
            imageUrl: '',
            recurring: {
              frequency: RecurringMessageFrequencyType.DAILY,
              text: 'FREQUENCY',
              reoptin: 'ENABLED',
            },
          },
        ],
      },
      tags: [],
      status: 'draft',
    },
    isLoading: false,
    isSaved: false,
    isActive: false,
    isShowRecurringMessageDialog: false,
  },
  reducers: {
    setIsActive: (state, action) => ({
      ...state,
      isActive: action.payload,
    }),
    setIsSaved: (state, action) => ({
      ...state,
      isSaved: action.payload,
    }),
    setIsLoading: (state, action) => ({
      ...state,
      isLoading: action.payload,
    }),
    setData: (state, action) => ({
      ...state,
      data: {
        ...state.data,
        ...action.payload,
      },
    }),
    setState: (state, action) => ({
      ...state,
      ...action.payload,
    }),
  },
});

export const { setIsSaved, setIsLoading, setData, setState, setIsActive } =
  recurringMessageSlice.actions;

export const getData = (orgId, id) => async dispatch => {
  try {
    dispatch(setIsLoading(true));

    const response = await RecurringMessageService.getData(orgId, id);
    dispatch(setData(response));
    dispatch(setIsActive(response?.status !== RecurringMessageStatus.DRAFT));

    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setData({}));
    dispatch(setIsLoading(false));
    dispatch(errorHandle(error));
  }
};

const checkData = data => {
  const { name, keyword, contents, award } = data || {};

  return (
    validateText(name) &&
    validateMax(name, 45) &&
    validateText(keyword) &&
    validateRecurringMessageContents(contents) &&
    (award?.enabled ? !!award?.value : true)
  );
};

export const saveData = (orgId, id) => async (dispatch, getStore) => {
  try {
    dispatch(setIsLoading(true));
    dispatch(setIsSaved(true));

    const { data } = getStore().recurringMessage;

    const isDataVerify = checkData(data);

    if (isDataVerify) {
      await RecurringMessageService.saveData(orgId, id, {
        name: data?.name,
        keyword: data?.keyword,
        contents: data?.contents,
        award: data?.award,
        ref: data?.ref,
      });
      dispatch(
        enqueueSnackbar({
          variant: SnackBarType.SUCCESS,
          message: i18n.t(`success-save`),
        }),
      );
    } else {
      dispatch(errorHandle('data-error'));
    }

    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(errorHandle(error));
  }
};

export default recurringMessageSlice.reducer;
